"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MIN_MASSACHUSETTS_AMT = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiMoney = _interopRequireDefault(require("ui-money"));
var _currencyField = _interopRequireDefault(require("./currencyField"));
var _revisionAmount = _interopRequireDefault(require("./message/invalid/revisionAmount"));
var _secondaryAmount = _interopRequireDefault(require("./message/invalid/secondaryAmount"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var toDollar = function toDollar(number) {
  return new _uiMoney.default(number, 'USD').format(0);
};
var MULTIPLE_PROVIDER_FLOW = 'MP';
var MIN_MASSACHUSETTS_AMT = 6001;
exports.MIN_MASSACHUSETTS_AMT = MIN_MASSACHUSETTS_AMT;
var PlanRevisor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PlanRevisor, _Component);
  var _super = _createSuper(PlanRevisor);
  function PlanRevisor() {
    var _this;
    (0, _classCallCheck2.default)(this, PlanRevisor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleAmountChange", function (clientId) {
      var onAmountChange = _this.props.onAmountChange;
      if (clientId) {
        return function (data) {
          onAmountChange(true, {
            clientId: clientId,
            amount: data.floatValue
          });
        };
      }
      return function (data) {
        var amount = data.floatValue;
        onAmountChange(false, {
          amount: amount
        });
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRemoveProvider", function (clientId) {
      var _this$props = _this.props,
        removeProvider = _this$props.removeProvider,
        onAmountChange = _this$props.onAmountChange,
        payeeAmounts = _this$props.payeeAmounts,
        _this$props$payees = (0, _slicedToArray2.default)(_this$props.payees, 1),
        primaryPayee = _this$props$payees[0];
      return function (e) {
        e.preventDefault();
        removeProvider(clientId);
        var primaryClientId = primaryPayee.id || primaryPayee.clientId;
        onAmountChange(false, {
          amount: payeeAmounts[primaryClientId]
        });
      };
    });
    return _this;
  }
  (0, _createClass2.default)(PlanRevisor, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        application = _this$props2.application,
        payees = _this$props2.payees,
        addProvider = _this$props2.addProvider,
        payeeAmounts = _this$props2.payeeAmounts,
        changeAmount = _this$props2.changeAmount,
        hasSubmitted = _this$props2.hasSubmitted,
        maxPayeeCount = _this$props2.maxPayeeCount,
        hasValidOffers = _this$props2.hasValidOffers,
        isMAFRPLoan = _this$props2.isMAFRPLoan,
        minAmount = _this$props2.minAmount,
        maxAmount = _this$props2.maxAmount;
      var creditLimit = application.creditLimit,
        customFlow = application.customFlow;
      var btnAdd = customFlow === MULTIPLE_PROVIDER_FLOW && /*#__PURE__*/_react.default.createElement("div", {
        className: "revision-container__add-provider"
      }, /*#__PURE__*/_react.default.createElement("button", {
        disabled: payees && payees.length >= maxPayeeCount ? true : undefined,
        className: "btn revision-container__add_provider",
        onClick: addProvider
      }, "Add Provider"), /*#__PURE__*/_react.default.createElement("span", {
        className: "help-icon pf-sprite D-ib Pos-R top-5 left-5"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "Pos-A D-n basic-black-tooltip tni"
      }, "Automatically allocate funds to a second office for their portion of the case.")));
      var rootClasses = (0, _classnames.default)('revision-container', {
        'revision-container--multiple': payees && payees.length > 1
      });
      var currencyClasses = (0, _classnames.default)('revision-container__input', {
        'revision-container__input--invalid': !hasValidOffers
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: rootClasses
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "revision-container__requested"
      }, "Available credit: ", toDollar(creditLimit)), payees && payees.length <= 1 ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "revision-container__label"
      }, "Plan Amount: "), /*#__PURE__*/_react.default.createElement(_currencyField.default, Object.assign({}, this.props, {
        className: currencyClasses,
        value: changeAmount,
        onAmountChange: this.handleAmountChange()
      })), btnAdd, /*#__PURE__*/_react.default.createElement(_revisionAmount.default, {
        changeAmount: changeAmount,
        minMasschusettesAmt: MIN_MASSACHUSETTS_AMT,
        minAmount: minAmount,
        maxAmount: maxAmount,
        isMA_FRPLoan: isMAFRPLoan,
        hasValidOffers: hasValidOffers
      })) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_revisionAmount.default, {
        changeAmount: changeAmount,
        minMasschusettesAmt: MIN_MASSACHUSETTS_AMT,
        minAmount: minAmount,
        maxAmount: maxAmount,
        isMA_FRPLoan: isMAFRPLoan,
        hasValidOffers: hasValidOffers
      }), /*#__PURE__*/_react.default.createElement(_secondaryAmount.default, {
        hasSubmitted: hasSubmitted,
        payees: payees,
        payeeAmounts: payeeAmounts
      }), payees.map(function (payee, idx) {
        var clientId = payee.id || payee.clientId;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: idx + '_payee',
          className: "payee"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "revision-container__label"
        }, payee.clientDisplayName.trim(), idx !== 0 && /*#__PURE__*/_react.default.createElement("a", {
          className: "payee__remove",
          onClick: _this2.handleRemoveProvider(clientId)
        }, "Remove")), /*#__PURE__*/_react.default.createElement(_currencyField.default, Object.assign({}, _this2.props, {
          onAmountChange: _this2.handleAmountChange(clientId),
          value: payeeAmounts[clientId] || 0,
          className: currencyClasses
        })));
      }), btnAdd, /*#__PURE__*/_react.default.createElement("div", {
        className: "change-total"
      }, /*#__PURE__*/_react.default.createElement("span", null, "New Plan Amount Total"), /*#__PURE__*/_react.default.createElement("span", {
        className: "change-total__value"
      }, /*#__PURE__*/_react.default.createElement("strong", null, toDollar(changeAmount))))))));
    }
  }]);
  return PlanRevisor;
}(_react.Component);
PlanRevisor.defaultProps = {
  payeeAmounts: {}
};
PlanRevisor.propTypes = {
  hasSubmitted: _propTypes.default.bool,
  maxPayeeCount: _propTypes.default.number,
  application: _propTypes.default.object,
  payeeAmounts: _propTypes.default.object,
  changeAmount: _propTypes.default.number,
  payees: _propTypes.default.array,
  onAmountChange: _propTypes.default.func,
  removeProvider: _propTypes.default.func,
  addProvider: _propTypes.default.func,
  hasValidOffers: _propTypes.default.bool,
  isMAFRPLoan: _propTypes.default.bool,
  minAmount: _propTypes.default.string,
  maxAmount: _propTypes.default.string
};
var _default = PlanRevisor;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions/dist/pf-revisions.scss');